import React from "react"
import { graphql } from "gatsby"
import { ArticleFieldsFragment, ThematicCardFieldsFragment } from "../../../../../graphql-types"
import * as styles from "./thematic-card.module.scss"
import { truncateText } from "../../../../tools/functions"
import { dateFormat } from "../../functions/functions"
import { useLocale } from "../../../../context/locale-context"
import Arrow from "../../../../../static/vectors/diagonal_arrow.svg"
import { ReactSVG } from "react-svg"
type ThematicCardProps = {
  data: ThematicCardFieldsFragment
  thematicFolderSlug: string
  projectsNewsInsightsPageSlug: string
}

const ThematicCard: React.FC<ThematicCardProps> = ({ data, thematicFolderSlug, projectsNewsInsightsPageSlug }) => {
    const { locale, defaultLocale } = useLocale()

    return (
    <div className={styles.container}>
      <div className={styles.thematic}>
        <div className={styles.thematicInfos}>
          <h2 className={styles.thematicTitle}>{data.tfThumbnailTitle ?? data.thematicTitle}</h2>
          <p className={styles.thematicDescription}>{data.tfThumbnailDescription ?? data.description}</p>
        </div>
        <button className={styles.button} onClick={() => {
          window.location.href = `${locale === defaultLocale ? `/${thematicFolderSlug}/${data.slug}` : `/${locale}/${thematicFolderSlug}/${data.slug}`}`
        }}>
          <div className={styles.buttonText}>{data.seeThematicLabel}</div>
          <ReactSVG className={styles.pictogram} src={Arrow} />
        </button>
      </div>
      <div className={styles.articles}>
          {data.articles.map((article) => (
            <a href={`${locale === defaultLocale ? `/${projectsNewsInsightsPageSlug}/${article.slug}` : `/${locale}/${projectsNewsInsightsPageSlug}/${article.slug}`}`} className={styles.article} key={article.id}>
                <p className={styles.articleInfos}>{article.thumbnailTitle ?? article.articleTitle} - {article.category?.label} - {dateFormat(article.date, locale)}</p>
                <p className={styles.articleDescription}>{truncateText(article.description, 120)}</p>
            </a>
        ))}
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ThematicCardFields on DatoCmsThematicFolder {
    id
    title
    metaDescription
    slug
    tfThumbnailTitle
    tfThumbnailDescription
    thematicTitle
    seeThematicLabel
    description
    category {
      title
    }
    articles {
      ...ArticleFields
    }
  }
`

export default ThematicCard

